// The one source for the embed snippets (redesign spec §7): an inline
// placement's Embed code dialog shows them and docs/embedding.md must match
// them (a test holds the two together). Origin is a parameter so the docs can show
// https://<host>; the admin passes window.location.origin, because /embed.js
// is served from the admin's own host.

export function staticSnippet(origin: string, token: string): string {
    return `<script src="${origin}/embed.js" data-token="${token}" async></script>`;
}

// The loader defines window.surveys as it parses, so the mount has to wait
// for it to load. Showing the load here as well is the difference between a
// snippet that works and one that throws on window.surveys.
export function mountSnippet(origin: string, token: string): string {
    return `// once, at startup
await new Promise((resolve, reject) => {
  const s = document.createElement("script");
  s.src = "${origin}/embed.js";
  s.onload = resolve;
  s.onerror = reject;
  document.head.appendChild(s);
});

// wherever the survey belongs
const handle = window.surveys.render(element, {
  token: "${token}",
  contextToken: "<a JWT your server signs>",
  onSubmitted(responseId) { /* link it to your own records */ },
});

// on unmount
handle.destroy();`;
}
